import { z } from 'zod';

/**
 * Current status/phase of the Writer's Room pipeline.
 */
export const WritersRoomPhaseSchema = z.enum([
  'idle',
  'snapshot',
  'prepared',
  'writing',
  'editing',
  'validating',
  'approved',
  'needs_fixes',
  'auto_fixing',
  'ready'
]);

export type WritersRoomPhase = z.infer<typeof WritersRoomPhaseSchema>;

/**
 * Writer's Room status object.
 */
export const WriterRoomStatusSchema = z.object({
  phase: WritersRoomPhaseSchema,
  lastRunId: z.string().optional(),
  attempts: z.number().default(0),
  error: z.string().optional(),
});

export type WriterRoomStatus = z.infer<typeof WriterRoomStatusSchema>;
